import { yupResolver } from "@hookform/resolvers/yup";
import React, { useMemo } from "react";
import { useFieldArray, useForm, useWatch } from "react-hook-form";
import { SdsForm } from "soft_digi";
import { SdsFormElementProps } from "soft_digi/dist/sdforms/SdsFromInterFace";
import * as yup from "yup";
import { SESSION_URLS } from "../../api/AdminUrls";
import { useSiteContext } from "../../contexts/SiteProvider";
import { post } from "../../services/smartApiService";
import "./sessions.scss";

interface HeaderProps {
  data?: any;
  session_id?: any;
  status_data: any;
}

const schema = yup.object().shape({
  sub_data: yup
    .array()
    .of(
      yup.object().shape({
        category_name: yup.string().required("Criteria is required"),
     question_id: yup
          .object({
            value: yup.string().required(),
            label: yup.string(),
          })
          .typeError("Question is required")
          .required("Question is required"),
       
        total_questions: yup
          .number()
          .typeError("Max Score must be a number")
          .required("Max Score is required")
           .min(0, "Max Score cannot be negative")
          .max(25, "Max Score cannot exceed 25"),
           answer_questions: yup
          .number()
          .typeError("Score must be a number")
          .required("Score is required")
          .min(0, "Score cannot be negative")
          .test(
            "is-less-than-or-equal-total",
            "Score cannot be greater than Max Score",
            function (value) {
              const { total_questions } = this.parent;
              if (typeof total_questions !== "number" || typeof value !== "number") {
                return true; // Skip validation if either is not a number
              }
              return value <= total_questions;
            }
          ),
      })
    )
    .min(1, "At least one item is required"),
});

const SessionuserSubform: React.FC<HeaderProps> = ({ data, status_data }) => {
  //  console.log("SessionuserSubform data", data);
  const {
    control,

    formState: { errors },
    handleSubmit,
    watch,
  } = useForm({
      resolver: yupResolver(schema),
    defaultValues: {
      sub_data: data?.sub_data || [],
    },
  });
  const { openModal, closeModal, user } = useSiteContext();
  console.log("status Data",data)

  const { fields, append, remove } = useFieldArray({
    control,
    name: "sub_data",
  });

  const subData = useWatch({
    control,
    name: "sub_data",
  });

  const totals = useMemo(() => {
    let totalScore = 0;
    let totalMaxScore = 0;

    subData?.forEach((item:any) => {
      const score = parseFloat(item?.answer_questions) || 0;
      const maxScore = parseFloat(item?.total_questions) || 0;
      totalScore += score;
      totalMaxScore += maxScore;
    });

    return { totalScore, totalMaxScore };
  }, [subData]);

  // const onSubmit = (formData: any) => {
  //   console.log("Submitted Data:", formData);
  // };

  // const addRemoveButtons = (index: number): React.ReactNode => (
  //   <div className="is-flex is-align-items-center">
  //     {index === fields.length - 1 && (
  //       <i
  //         className="fa fa-plus has-text-link mx-2 smart-cursor"
  //         onClick={() =>
  //           append({
  //             criteria: "",
  //             question: "",
  //             score: "",
  //             max_score: "",
  //           })
  //         }
  //       ></i>
  //     )}
  //     {index > 0 && (
  //       <i
  //         className="fa fa-trash has-text-danger mx-2 smart-cursor"
  //         onClick={() => remove(index)}
  //       ></i>
  //     )}
  //   </div>
  // );

  const getElements = (index: number): SdsFormElementProps[] => [
    {
      type: "LABEL",
      name: `sub_data.${index}.s_no`,
      width: 1,
      class_name: "ph-column-sno",
      labelComponent: <span>{index + 1}.</span>,
    },
    {
      type: "TEXTAREA",
      width: 3,
      name: `sub_data.${index}.category_name`,
      element: {
        isRequired: true,
        placeHolder: "Assessment criteria",
      },
    },
    {
      type: "SELECT_BOX",
      width: 3,
      name: `sub_data.${index}.question_id`,
      element: {
        isRequired: true,
        placeHolder: "Select question",
        options: data.sub_data[index].options || [],
      },
    },
     {
      type: "TEXT_BOX",
      width: 2,
      name: `sub_data.${index}.total_questions`,
      element: {
        isRequired: false,
        placeHolder: "Max Score",
      },
    },
    {
      type: "TEXT_BOX",
      width: 2,
      name: `sub_data.${index}.answer_questions`,
      element: {
        isRequired: false,
        placeHolder: "Score",
      },
    },
   
    // {
    //   type: "LABEL",
    //   width: 1,
    //   name: "actions",
    //   class_name: "has-text-centered p-4",
    //   labelComponent: addRemoveButtons(index),
    // },
  ];

  const onSubmit = (dt: any) => {
    // console.log("Submitted Data: ", data);
    let url = SESSION_URLS.INSERT_PRACTICE_SESSION;
    let payload = {
      session_id: data?.data?.session_id,
      sub_data: dt?.sub_data,
      session_user_id: data?.data?.ID,
    };
    const subscription = post(url, payload).subscribe((response) => {
      console.log("response form ", response.data);
      closeModal();
      //loadTableData();
    });
    return () => {
      subscription.unsubscribe();
    };
  };

  const SessionResultTable = () => {
  return (
    <div className="table-container ">
      {/* <h2 className="title is-5 ">Loco Pilot Details</h2> */}
      <table className="table is-fullwidth ">
        <tbody>
         
          <tr>

            <th> Name</th>
            <td>{data?.data?.ename}</td>
             <th> ID</th>
            <td>{data?.data?.euserid}</td>
            <th>Mobile No</th>
            <td>{data?.data?.mobile_no}</td>
           
          </tr>
         
         
        
        
        </tbody>
      </table>
    </div>
  );
};

  return (
    <>
      <div className="">
        {/* <table className="table is-fullwidth">
          <tbody>
            <tr>
              <th>Agency Name</th>
              <td>{status_data?.agency_name}</td>
              <th>Project Name</th>
              <td>{status_data?.project_name}</td>
              <th>Session ID</th>
              <td>{status_data?.session_id}</td>
            </tr>
            
          <tr>
            <th>Session date</th>
            <td>{changeDateTimeZone(status_data?.session_date)}</td>
          </tr>
        </tbody>
      </table> */}

     
     {SessionResultTable()}

      
  
    </div>
    
      <form className="sd-hims-batch-form" onSubmit={handleSubmit(onSubmit)}>
        {/* Table Header */}
        <div className="columns mb-0 has-background-grey-lighter is-multiline px-2 py-1">
          <div className="column is-1">
            <label className="is-size-5">S.No</label>
          </div>
          <div className="column is-3">
            <label className="is-size-5">Assessment Criteria</label>
          </div>
          <div className="column is-3">
            <label className="is-size-5">Question Asked</label>
          </div>
         
          <div className="column is-2">
            <label className="is-size-5">Max Score</label>
          </div>
           <div className="column is-2">
            <label className="is-size-5">Score</label>
          </div>
          {/* <div className="column is-1">
            <label className="is-size-7">Actions</label>
          </div> */}
        </div>

        {/* Scrollable Form Rows */}
        <div
          className="ph-items-form mt-1"
          // style={{ maxHeight: "300px", overflowY: "auto" }}
        >
          {fields.map((field, index) => (
            <div key={field.id} className="columns is-gapless">
              <SdsForm
                elements={getElements(index)}
                errors={errors}
                control={control}
                className="mb-1 is-flex-grow-1"
              />
            </div>
          ))}
       
        </div>

        {/* Totals Row */}
        <div className="columns mt-2 has-text-weight-semibold has-text-right is-align-items-center">
          <div className="column is-7 has-text-right">Total:</div>
          <div className="column is-2 has-text-left">
            {totals.totalMaxScore}
          </div>
          <div className="column is-2 has-text-left">{totals.totalScore}</div>
          
          <div className="column is-1"></div>
        </div>
        <div className="has-text-right smart-third-button">
  <button
            type="button"
            className="button is-link is-small mt-2  "
            onClick={handleSubmit(onSubmit)}
          >
            {" "}
            Submit Data
          </button>
        </div>
         
      </form>
      
    </>
  );
};

export default SessionuserSubform;
